export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/unselected-star-icon.png?bfc161cfdbcd6bd870fcc38a4cf390d9";